module.exports = __webpack_public_path__ + "img/practitioners-white.52732a25.png";